import Divisao from '@/spa/divisao/CadastroDivisao';

export default {
  path: 'divisao',
  name: 'divisao',
  component: Divisao,
};
